// Rótulos normativos da ficha `inspection-v1` (form §7.3).
// Namespace `inspection.catalog.v1.*` — cada versão tem o próprio subtree.

export const inspectionCatalogV1ZhCN = {
  common: {
    yes: "是",
    no: "否",
    na: "N/A",
    notApplicable: "不适用",
    good: "良好",
    regular: "一般",
    deficient: "差",
    observations: "备注",
    photos: "照片",
    others: "其他（请注明）",
    describe: "描述",
    local: "位置",
    note: "说明",
    type: "类型",
    value: "数值",
    flowRate: "流量",
    elevationM: "高程 (m)",
    lengthM: "长度 (m)",
    openingMm: "缝宽 (mm)",
    orientation: "方向",
    manifestation: "表现形式",
    solidCarryover: "可见固体携带",
    cleaningState: "清洁状态",
    structuralCondition: "结构状况",
    structuralConditions: "结构状况",
    addCrack: "添加裂缝",
    addSettlement: "添加沉降",
    addSeepage: "添加渗流",
    addErosion: "添加冲蚀",
    addLine: "添加一行",
    addOccurrence: "添加异常",
  },
  choices: {
    longitudinal: "纵向",
    transversal: "横向",
    crest: "坝顶",
    berms: "马道",
    slopes: "边坡",
    depression: "凹陷 / 塌陷",
    settlement: "沉降",
    grassNeedsPruning: "草本植物需修剪",
    controlledOrAbsentDuringRaising: "受控 / 加高期间无",
    shrubOrTreeVegetation: "灌木及/或乔木植被",
    absentWithoutRaising: "无加高且不存在",
  },
  placeholders: {
    local: "区段、坐标、桩号…",
    othersDescribe: "请说明残余发现…",
    othersObservations: "补充备注…",
    lengthExample: "例：3,20",
    openingExample: "例：5",
    flowValue: "数值与单位（例：0,5 L/s）",
    elevation: "高程 (m)…",
    beachLength: "例：15,00 m…",
    flowRate: "流量：…",
  },
  steps: {
    generalData: "基本信息",
    accesses: "通道状况",
    damBody: "坝体 / 坝肩",
    reservoir: "库区",
    spillway: "溢洪道",
    instrumentation: "监测仪器（物理完整性、标识、通道）",
    beachCondition: "干滩条件",
    tailingsWaterIntake: "尾矿输送管 / 取水",
    conservationState: "维护状态",
    generalComments: "总体意见",
    signatures: "签字",
  },
  stepShort: {
    accesses: "通道",
    damBody: "坝体",
    reservoir: "库区",
    spillway: "溢洪道",
    instrumentation: "监测仪器",
    beachCondition: "干滩条件",
    tailingsWaterIntake: "输送管 / 取水",
  },
  sections: {
    pests: "昆虫 / 动物存在情况",
    internalDrainage: "内部排水",
    geomembraneOccurrences: "土工膜异常",
  },
  occurrence: {
    crack: "裂缝",
    settlement: "沉降",
    seepage: "渗流",
    erosion: "冲蚀",
    geomembrane: "土工膜",
  },
  items: {
    accesses: {
      generalConservation: "总体维护",
      slopes: "边坡",
      floorPavement: "路面铺装",
      drainageDevices: "排水设施",
    },
    damBody: {
      cracksIdentified: "已识别裂缝",
      settlementsIdentified: "已识别沉降",
      seepagesIdentified: "已识别渗流",
      surfaceErosions: "表面冲蚀",
      surfaceDrainage: "地表排水",
      drainageChannel: "排水沟",
      vegetalCover: "植被护面",
      pests: {
        termitesRodents: "蚁巢 / 白蚁 / 啮齿动物",
        animals: "动物（检查足迹 / 粪便）",
        burrows: "洞穴或孔洞",
      },
      internalDrainage: {
        outletSilting: "排水/胶体出口淤积",
        solidCarryover: "可见固体携带",
        flowChange: "流量显著变化",
        drainSaturation: "排水口周围饱和",
        flowMeterOperational: "流量计量测正常",
        flowMeasured: "巡检中测得的内部排水流量",
      },
      complementaryStructures: "附属结构",
      reinforcement: "加固结构（反压堆、平衡马道等）",
      saddleDike: "鞍部副坝",
      sump: "与结构相连的集水井",
    },
    reservoir: {
      bankCondition: "岸坡状况（冲蚀或不稳定过程）",
      impermeabilized: "库区已防渗",
      geomembraneConservation: "土工膜维护状态",
      operationalFreeboard: "运行超高",
    },
    spillway: {
      type: "溢洪道类型",
      inletSectionCondition: "进口断面状况",
      outletSectionCondition: "出口断面状况",
      stillingBasinCondition: "消力池状况",
      structuralCondition: "结构状况",
      hasEmergencySpillway: "是否设有应急溢洪道？",
    },
    instrumentation: {
      access: "仪器通道",
      protection: "仪器防护",
      conservationState: "维护状态",
      localGaugesCondition:
        "现场量测器具状况（水尺、雨量刻度、量桶、带声波传感器的卷尺）",
      identification: "仪器标识",
    },
    beachCondition: {
      tailingsDisposal: "库内尾矿排放/处置",
      safeWaterDistance: "水面至坝顶的安全距离",
      physicalSignaling: "实体标志运行状况（浮筒）",
      beachLengthVsCrest: "干滩长度相对坝顶（如适用）",
    },
    tailingsWaterIntake: {
      tailingsInflow: "库内是否正在排入尾矿？",
      tailingsLineLeak: "尾矿管线是否有泄漏迹象？",
      waterPumpingActive: "是否正在从库内抽水？请注明是否运行",
      waterPipeLeak: "水管是否有泄漏迹象？",
      intakeOperating: "取水系统是否正常运行？流量：",
      bargeAccessOperating: "浮船取水系统通道是否可用？",
    },
  },
} as const;
